import { faAccountCircle } from './faAccountCircle'
import { faArrowsSpinClassic } from './faArrowsSpinClassic'
import { faArrowsSpinDuotone } from './faArrowsSpinDuotone'
import { faArrowUp } from './faArrowUp'
import { faBriefcase } from './faBriefcase'
import { faBuilding } from './faBuilding'
import { faBuildingCircleCheckClassic } from './faBuildingCircleCheckClassic'
import { faBuildingCircleCheckDuotone } from './faBuildingCircleCheckDuotone'
import { faBuildings } from './faBuildings'
import { faCalendarDaysClassic } from './faCalendarDaysClassic'
import { faCalendarDaysDuotone } from './faCalendarDaysDuotone'
import { faCar } from './faCar'
import { faCat } from './faCat'
import { faChargingStation } from './faChargingStation'
import { faChartMixed } from './faChartMixed'
import { faChevronDown } from './faChevronDown'
import { faCircleCheck } from './faCircleCheck'
import { faCircleInfo } from './faCircleInfo'
import { faCircleUser } from './faCircleUser'
import { faClockTwoClassic } from './faClockTwoClassic'
import { faClockTwoDuotone } from './faClockTwoDuotone'
import { faCopy } from './faCopy'
import { faCouch } from './faCouch'
import { faDesktopArrowDown } from './faDesktopArrowDown'
import { faDisplayChartClassic } from './faDisplayChartClassic'
import { faDisplayChartDuoTone } from './faDisplayChartDuoTone'
import { faDog } from './faDog'
import { faDownload } from './faDownload'
import { faEnvelope } from './faEnvelope'
import { faEnvelopeDotClassic } from './faEnvelopeDotClassic'
import { faEnvelopeDotDuotone } from './faEnvelopeDotDuotone'
import { faEye } from './faEye'
import { faEyeSlash } from './faEyeSlash'
import { faFileCircleQuestion } from './faFileCircleQuestion'
import { faFileLines } from './faFileLines'
import { faFilterCircleDollar } from './faFilterCircleDollar'
import { faFilterCircleDollarClassic } from './faFilterCircleDollarClassic'
import { faFilterCircleDollarDuotone } from './faFilterCircleDollarDuotone'
import { faHeadset } from './faHeadset'
import { faHelp } from './faHelp'
import { faIdCard } from './faIdCard'
import { faKey } from './faKey'
import { faLaptopClassic } from './faLaptopClassic'
import { faLaptopDuotone } from './faLaptopDuotone'
import { faLocationDot } from './faLocationDot'
import { faLock } from './faLock'
import { faLogout } from './faLogout'
import { faMapLocationDotClassic } from './faMapLocationDotClassic'
import { faMapLocationDotDuotone } from './faMapLocationDotDuotone'
import { faPeace } from './faPeace'
import { faPeopleGroupClassic } from './faPeopleGroupClassic'
import { faPeopleGroupDuotone } from './faPeopleGroupDuotone'
import { faPhone } from './faPhone'
import { faPhoneArrowDownLeft } from './faPhoneArrowDownLeft'
import { faPhoneMissed } from './faPhoneMissed'
import { faPhoneRotaryClassic } from './faPhoneRotaryClassic'
import { faPhoneRotaryDuotone } from './faPhoneRotaryDuotone'
import { faPhoneVolumeClassic } from './faPhoneVolumeClassic'
import { faPhoneVolumeDuotone } from './faPhoneVolumeDuotone'
import { faRefresh } from './faRefresh'
import { faSmoking } from './faSmoking'
import { faSnowBlowing } from './faSnowBlowing'
import { faSquareEnvelope } from './faSquareEnvelope'
import { faStopWatchClassic } from './faStopWatchClassic'
import { faStopWatchDuotone } from './faStopWatchDuotone'
import { faTools } from './faTools'
import { faTrash } from './faTrash'
import { faUser } from './faUser'
import { faWashingMachine } from './faWashingMachine'
import { faWatchClassic } from './faWatchClassic'
import { faWatchDuotone } from './faWatchDuotone'
import { faWheelchairMove } from './faWheelchairMove'

export default {
  faFilterCircleDollar,
  faPeace,
  faBuildings,
  faHelp,
  faAccountCircle,
  faUser,
  faLogout,
  faHeadset,
  faFileCircleQuestion,
  faBriefcase,
  faBuilding,
  faBuildingCircleCheckDuotone,
  faBuildingCircleCheckClassic,
  faArrowsSpinDuotone,
  faArrowsSpinClassic,
  faCalendarDaysDuotone,
  faCalendarDaysClassic,
  faFilterCircleDollarDuotone,
  faFilterCircleDollarClassic,
  faEnvelopeDotDuotone,
  faEnvelopeDotClassic,
  faPhoneVolumeDuotone,
  faPhoneVolumeClassic,
  faLaptopDuotone,
  faLaptopClassic,
  faDisplayChartDuoTone,
  faDisplayChartClassic,
  faDownload,
  faSquareEnvelope,
  faRefresh,
  faLock,
  faCircleCheck,
  faCircleInfo,
  faChartMixed,
  faPhoneRotaryDuotone,
  faPhoneRotaryClassic,
  faWatchDuotone,
  faWatchClassic,
  faStopWatchDuotone,
  faStopWatchClassic,
  faPeopleGroupDuotone,
  faPeopleGroupClassic,
  faPhoneArrowDownLeft,
  faPhoneMissed,
  faMapLocationDotDuotone,
  faMapLocationDotClassic,
  faClockTwoDuotone,
  faClockTwoClassic,
  faPhone,
  faEnvelope,
  faLocationDot,
  faDesktopArrowDown,
  faKey,
  faCouch,
  faDog,
  faCat,
  faCar,
  faChargingStation,
  faSnowBlowing,
  faWashingMachine,
  faSmoking,
  faWheelchairMove,
  faTrash,
  faEye,
  faEyeSlash,
  faCopy,
  faArrowUp,
  faCircleUser,
  faFileLines,
  faTools,
  faChevronDown,
  faIdCard
}
